export default __webpack_public_path__ + "static/media/prison.73059bc6.png";